const markColor = "text-[#977dff]";

export const experienceFeatures = {
  version: "experience",
  imageSrc: "/pricing/experience.webp",
  title: "入门版",
  subTitle: "准备入局TK的卖家起步运营",
  packageId: 48,
  period: "/月",
  gradientColor: "linear-gradient(200deg, #EEE 3%, rgb(255, 255, 255) 20%)",
  btnColor: "linear-gradient(90deg, #8C8C9A 0%, #C3C3C7 100%)",
  seabay: false,
  features: [
    {
      description: "搜索结果",
      value: "前100",
    },
    {
      description: "搜索功能",
      value: "300次/月",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近30天",
    },
    {
      description: "数据导出",
      value: false,
      className: "min-h-8",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: false,
    },
    // {
    //   description: "AI短视频创作",
    //   value: "30次/月",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "5次/月",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "5次/月",
    },
    {
      description: "视频脚本智能仿写",
      value: "5次/月",
    },
    {
      description: "卖点可视化",
      value: "5次/月",
    },
    {
      description: "分镜创意",
      value: "5次/月",
    },
    {
      description: "智能生成样片",
      value: false,
    },
    {
      description: "智能成片导出",
      value: false,
    },
    {
      description: "评论分析",
      value: "限时免费",
    },
    {
      description: "AI 品类洞察报告",
      value: "1次/月",
    },
    {
      description: "小匠 AI 问答",
      value: "5次/天",
    },
  ],
};

export const basicFeatures = {
  version: "basic",
  imageSrc: "/pricing/basic.webp",
  title: "标准版",
  subTitle: "个人卖家初级运营",
  packageId: 47,
  period: "/月",
  gradientColor: "linear-gradient(200deg, #F8F4FF 3%, rgb(255, 255, 255) 20%)",
  btnColor: "linear-gradient(90deg, #A99EFF 0%, #DDC6FF 100%)",
  seabay: false,
  features: [
    {
      description: "搜索结果",
      value: "前300",
    },
    {
      description: "搜索功能",
      value: "100次/天",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近90天",
    },
    {
      description: "数据导出",
      value: "前100条\n10次/月",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: false,
    },
    // {
    //   description: "AI短视频创作",
    //   value: "90次/月",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
    {
      description: "TikTok美区商品定价工具",
      value: true,
    },
    {
      description: "TikTok美区达人邀约话术",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "30次/月",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "30次/月",
    },
    {
      description: "视频脚本智能仿写",
      value: "30次/月",
    },
    {
      description: "卖点可视化",
      value: "20次/月",
    },
    {
      description: "分镜创意",
      value: "20次/月",
    },
    {
      description: "智能生成样片",
      value: false,
    },
    {
      description: "智能成片导出",
      value: false,
    },
    {
      description: "评论分析",
      value: "限时免费",
    },
    {
      description: "AI 品类洞察报告",
      value: "5次/月",
    },
    {
      description: "小匠 AI 问答",
      value: "10次/天",
    },
  ],
};

export const professionalFeatures = {
  version: "professional",
  imageSrc: "/pricing/professional.webp",
  title: "专业版",
  subTitle: "成熟卖家进阶运营",
  packageId: 45,
  period: "/半年",
  gradientColor: "linear-gradient(200deg, #FFFBF0 3%, rgb(255, 255, 255) 20%)",
  btnColor: "linear-gradient(90deg, #EDB347 0%, #FBD36E 100%)",
  seabay: false,
  features: [
    {
      description: "搜索结果",
      value: "前1000",
    },
    {
      description: "搜索功能",
      value: "300次/天",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近180天",
    },
    {
      description: "数据导出",
      value: "前200条\n100次/月",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: false,
    },
    // {
    //   description: "AI短视频创作",
    //   value: "150次/月",
    // },
    // {
    //   description: "达人数据导出",
    //   value: "前500",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
    {
      description: "TikTok美区商品定价工具",
      value: true,
    },
    {
      description: "TikTok美区达人邀约话术",
      value: true,
    },
    {
      description: "专属会员VIP一对一指导",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "100次/月",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "100次/月",
    },
    {
      description: "视频脚本智能仿写",
      value: "100次/月",
    },
    {
      description: "卖点可视化",
      value: "50次/月",
    },
    {
      description: "分镜创意",
      value: "50次/月",
    },
    {
      description: "智能生成样片",
      value: false,
    },
    {
      description: "智能成片导出",
      value: false,
    },
    {
      description: "评论分析",
      value: "限时免费",
    },
    {
      description: "AI 品类洞察报告",
      value: "30次/月",
    },
    {
      description: "小匠 AI 问答",
      value: "20次/天",
    },
  ],
};

export const exclusiveFeatures = {
  version: "exclusive",
  imageSrc: "/pricing/exclusive.webp",
  title: "尊享版",
  subTitle: "大卖精细化运营",
  packageId: 43,
  period: "/年",
  gradientColor: "linear-gradient(200deg, #F3F1FF 3%, rgb(255, 255, 255) 20%)",
  btnColor: "linear-gradient(90deg, #322792 0%, #7325DB 100%)",
  seabay: "300{placeholder}/月",
  features: [
    {
      description: "搜索结果",
      value: "不限",
    },
    {
      description: "搜索功能",
      value: "不限",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近365天",
    },
    {
      description: "数据导出",
      value: "前1000条\n200次/月",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: false,
    },
    // {
    //   description: "AI短视频创作",
    //   value: "300次/月",
    // },
    // {
    //   description: "达人数据导出",
    //   value: "前1000",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
    {
      description: "TikTok美区商品定价工具",
      value: true,
    },
    {
      description: "TikTok美区达人邀约话术",
      value: true,
    },
    {
      description: "专属会员VIP一对一指导",
      value: true,
    },
    {
      description: "出海匠大咖店铺运营课堂",
      value: true,
    },
    {
      description: "出海匠机构MCN资源对接",
      value: true,
    },
    {
      description: "出海匠大咖闭门会邀约",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "200次/月",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "200次/月",
    },
    {
      description: "视频脚本智能仿写",
      value: "200次/月",
    },
    {
      description: "卖点可视化",
      value: "100次/月",
    },
    {
      description: "分镜创意",
      value: "100次/月",
    },
    {
      description: "智能生成样片",
      value: true,
    },
    {
      description: "智能成片导出",
      value: "500条/月",
    },
    {
      description: "评论分析",
      value: "限时免费",
    },
    {
      description: "AI 品类洞察报告",
      value: "50次/月",
    },
    {
      description: "小匠 AI 问答",
      value: "50次/天",
    },
  ],
};

export const enterpriseFeatures = {
  version: "enterprise",
  imageSrc: "/pricing/enterprise.webp",
  title: "企业版",
  // subTitle: "5人以上团队卖家品牌化运营",
  subTitle: "1 个主账号 + 2 个子账号",
  packageId: 41,
  period: "/年",
  gradientColor: "linear-gradient(200deg, #FFF6EF 3%, rgb(255, 255, 255) 20%)",
  btnColor: "linear-gradient(90deg, #18151F 0%, #CB6D29 100%)",
  seabay: "500{placeholder}/月",
  features: [
    {
      description: "搜索结果",
      value: "不限",
    },
    {
      description: "搜索功能",
      value: "不限",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近365天",
    },
    {
      description: "数据导出",
      value: "前1000条\n500次/月",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: 2,
      isHighlighted: true,
    },

    // {
    //   description: "AI短视频创作",
    //   value: "1500次/月",
    // },
    // {
    //   description: "达人数据导出",
    //   value: "前1000",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
    {
      description: "TikTok美区商品定价工具",
      value: true,
    },
    {
      description: "TikTok美区达人邀约话术",
      value: true,
    },
    {
      description: "专属会员VIP一对一指导",
      value: true,
    },
    {
      description: "出海匠大咖店铺运营课堂",
      value: true,
    },
    {
      description: "出海匠机构MCN资源对接",
      value: true,
    },
    {
      description: "出海匠大咖闭门会邀约",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "500次/月",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "500次/月",
    },
    {
      description: "视频脚本智能仿写",
      value: "500次/月",
    },
    {
      description: "卖点可视化",
      value: "200次/月",
    },
    {
      description: "分镜创意",
      value: "200次/月",
    },
    {
      description: "智能生成样片",
      value: true,
    },
    {
      description: "智能成片导出",
      value: "1000条/月",
    },
    {
      description: "评论分析",
      value: "限时免费",
    },
    {
      description: "AI 品类洞察报告",
      value: "100次/月",
    },
    {
      description: "小匠 AI 问答",
      value: "100次/天",
    },
  ],
};

export const enterprisePlusFeatures = {
  version: "enterprisePlus",
  imageSrc: "/pricing/enterprisePlus.webp",
  title: "企业定制版",
  subTitle: "大型公司定制化服务",
  packageId: 30,
  period: "/年",
  gradientColor: "linear-gradient(180deg, #FDF0FF 3%, #EBEAFF 20%)",
  btnColor: "linear-gradient(90deg, #4E56F5 0%, #DA7EDE 100%)",
  seabay: "定制化{placeholder}",
  features: [
    {
      description: "搜索结果",
      value: "不限",
    },
    {
      description: "搜索功能",
      value: "不限",
      showSearchIcon: true,
    },
    {
      description: "历史数据",
      value: "近365天",
    },
    {
      description: "数据导出",
      value: "定制化",
      className: "min-h-8",
      showExportIcon: true,
    },
    {
      description: "额外子账号",
      value: "定制化",
    },
    // {
    //   description: "AI短视频创作",
    //   value: "定制化",
    // },
    // {
    //   description: "达人数据导出",
    //   value: "不限",
    // },
    {
      description: "TikTok新手开店大礼包",
      value: true,
    },
    {
      description: "TikTok美区商品定价工具",
      value: true,
    },
    {
      description: "TikTok美区达人邀约话术",
      value: true,
    },
    {
      description: "专属会员VIP一对一指导",
      value: true,
    },
    {
      description: "出海匠大咖店铺运营课堂",
      value: true,
    },
    {
      description: "出海匠机构MCN资源对接",
      value: true,
    },
    {
      description: "出海匠大咖闭门会邀约",
      value: true,
    },
  ],
  aiFeatures: [
    {
      description: "视频内容解构",
      value: "定制化",
      showScriptIcon: true,
    },
    {
      description: "带货视频脚本生成",
      value: "定制化",
    },
    {
      description: "视频脚本智能仿写",
      value: "定制化",
    },
    {
      description: "卖点可视化",
      value: "定制化",
    },
    {
      description: "分镜创意",
      value: "定制化",
    },
    {
      description: "智能生成样片",
      value: true,
    },
    {
      description: "智能成片导出",
      value: "定制化",
    },
    {
      description: "评论分析",
      value: "定制化",
    },
    {
      description: "AI 品类洞察报告",
      value: "定制化",
    },
    {
      description: "小匠 AI 问答",
      value: "定制化",
    },
  ],
};
